export function verificarDiaMes(dia: number, mes: number) {
  const meses = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  const result = meses[mes] > dia ? dia : meses[mes];

  return result;
}
